import { call, put, all } from "redux-saga/effects";
import { reportError, reportSuccess } from "../actions/erroractions";
import {
  resetPasswordFailed,
  resetPasswordSuccess,
} from "../actions/resetpasswordactions";
import { moveToMainPage } from "../actions/routeactions";
import { resetPasswordAPI } from "../api/ResetPasswordCall";

export function* resetPasswordSaga(action) {
  try {
    const result = yield call(resetPasswordAPI, action);
    
    if (result.ok) {
      yield all([
        put(reportSuccess("Password updated")),
        put(resetPasswordSuccess()),
        put(moveToMainPage(false)),
      ]);
    } else {
      yield all([
        put(resetPasswordFailed()),
        put(reportError(result.message)),
      ]);
    }
  } catch (e) {
    yield all([
      put(reportError("Unable to reach server")),
      put(resetPasswordFailed()),
    ]);
  }
}
